import React, { useState } from "react";
import { motion } from "framer-motion";
import { MapPin, Phone, Mail, Globe } from "lucide-react";

export default function ContactSection() {
  const [activeTab, setActiveTab] = useState("general");

  const generalFormUrl =
    "https://docs.google.com/forms/d/e/1FAIpQLSep1w7bWc2UAbndS6nTqk2V0HxmDY1LB2npaorzsFtkr9T-6Q/viewform?usp=dialog";

  return (
    <section id="contact" className="py-12 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <span className="text-[#d4a106] font-medium tracking-wider uppercase text-sm">
            Contact Us
          </span>
          <h2 className="text-4xl md:text-5xl font-light text-[#1a237e] mt-4 mb-6">
            Get In <span className="font-medium">Touch</span>
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Reach out to us for product inquiries, quotations, or technical
            discussions. Our team will respond promptly.
          </p>
        </motion.div>

        <div className="grid lg:grid-cols-5 gap-12">
          {/* Left: Contact Info */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="lg:col-span-2"
          >
            <div className="bg-[#1a237e] rounded-3xl p-8 h-full">
              <img
                src="https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/user_6963e9b5a113aa6fea81fbb3/ee56ae49d_Jasmine_Enterprises_Logo__3_-removebg-preview.png"
                alt="Jasmine Enterprises"
                className="h-16 mb-10 brightness-0 invert"
              />

              <div className="space-y-6 text-sm">
                <InfoItem
                  icon={MapPin}
                  label="Address"
                  value="Plot No. 41, Door No.2, 3rd Cross Street, Brindhavan Nagar, Valasaravakkam, Chennai - 600 087, India"
                />
                <InfoItem
                  icon={Phone}
                  label="Phone"
                  value="+91 44 4335 6128"
                />
                <InfoItem
                  icon={Mail}
                  label="Email"
                  value="sales@jasmineenterprises.in"
                />
                <InfoItem
                  icon={Globe}
                  label="Website"
                  value="www.jasmineenterprises.in"
                />
              </div>
            </div>
          </motion.div>

          {/* Right: Google Form */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="lg:col-span-3"
          >
            <div className="bg-white rounded-3xl p-8 shadow-sm">
              {/* Tabs */}
              <div className="flex justify-center mb-8">
                <div className="bg-gray-100 rounded-full p-1 flex">
                  <button
                    onClick={() => setActiveTab("general")}
                    className={`px-8 py-2 rounded-full text-sm font-medium transition-all ${
                      activeTab === "general"
                        ? "bg-[#1a237e] text-white shadow"
                        : "text-gray-600 hover:text-[#1a237e]"
                    }`}
                  >
                    Product / General Inquiry
                  </button>
                </div>
              </div>

              {/* Google Form */}
              <div className="w-full h-[520px] md:h-[620px]">
                <iframe
                  src={generalFormUrl}
                  width="100%"
                  height="100%"
                  frameBorder="0"
                  title="Contact Form"
                  className="rounded-xl border border-gray-200"
                >
                  Loading…
                </iframe>
              </div>

              <p className="text-center text-gray-500 text-sm mt-4">
                If the form doesn’t load,{" "}
                <a
                  href={generalFormUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#1a237e] font-medium hover:underline"
                >
                  open it in a new tab
                </a>
                .
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}

/* Reusable info row */
function InfoItem({ icon: Icon, label, value }) {
  return (
    <div className="flex gap-4">
      <div className="w-10 h-10 bg-[#f9d71c]/15 rounded-lg flex items-center justify-center shrink-0">
        <Icon className="w-5 h-5 text-[#f9d71c]" />
      </div>
      <div>
        <p className="text-white/50">{label}</p>
        <p className="text-white leading-relaxed">{value}</p>
      </div>
    </div>
  );
}
